import { Component } from 'react';
import { List } from 'foundations-components/transitional/components/List';
import TeamCheckbox from './TeamCheckbox';
import TeamsZeroState from './TeamsZeroState';
import { jsx as _jsx } from "react/jsx-runtime";
export default class Teams extends Component {
  renderTeam(team) {
    const {
      childTeams
    } = team;
    if (childTeams.length) {
      return [this.renderTeamCheckbox(team), this.renderTeamsList(team)];
    }
    return this.renderTeamCheckbox(team);
  }
  renderTeamsList(team) {
    const {
      childTeams
    } = team;
    return /*#__PURE__*/_jsx(List, {
      paddingInlineStart: "700",
      wrapChildren: true,
      children: childTeams.map(childTeam => this.renderTeam(childTeam))
    });
  }
  renderTeamCheckbox(team) {
    const {
      selectedTeams,
      handleTeamChange,
      canAssignContent
    } = this.props;
    return /*#__PURE__*/_jsx(TeamCheckbox, {
      onTeamChange: handleTeamChange,
      selectedTeams: selectedTeams,
      team: team,
      canAssignContent: canAssignContent
    }, `${team.id}-team-checkbox`);
  }
  render() {
    const {
      teams
    } = this.props;
    if (!teams.length) {
      return /*#__PURE__*/_jsx(TeamsZeroState, {});
    }
    return /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: teams.map(team => this.renderTeam(team))
    });
  }
}